/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentUploaderType = {
    Staff: 'staff',
    Participant: 'participant',
} as const;
export type DocumentUploaderType = typeof DocumentUploaderType[keyof typeof DocumentUploaderType];


export function instanceOfDocumentUploaderType(value: any): boolean {
    for (const key in DocumentUploaderType) {
        if (Object.prototype.hasOwnProperty.call(DocumentUploaderType, key)) {
            if (DocumentUploaderType[key as keyof typeof DocumentUploaderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DocumentUploaderTypeFromJSON(json: any): DocumentUploaderType {
    return DocumentUploaderTypeFromJSONTyped(json, false);
}

export function DocumentUploaderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentUploaderType {
    return json as DocumentUploaderType;
}

export function DocumentUploaderTypeToJSON(value?: DocumentUploaderType | null): any {
    return value as any;
}

export function DocumentUploaderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DocumentUploaderType {
    return value as DocumentUploaderType;
}

